/**
 * Created by mukund on 2/18/16.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('lmsUpload', {
                parent: 'site',
                url: '/lms/upload/:collectionId/:origin/:authToken',
                data: {
                    roles: [],
                    pageTitle: 'upload.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/upload/templates/upload.html',
                        controller: 'UploadController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('upload');
                        return $translate.refresh();
                    }]
                }
            });
    });
